// AUTO-GENERATED: région -> nom du picklist Deluge legacy
export const REGION_TO_LEGACY_FIELD = {
  "Abitibi-Témiscamingue": "LISTE_DES_BUREAUX_D_AIDE_JURIDIQUE_DU_CENTRE_Abitibi_T_miscamingue",
  "Côte-Nord": "LISTE_DES_BUREAUX_D_AIDE_JURIDIQUE_DU_CENTRE_C_te_Nord",
  "Estrie": "LISTE_DES_BUREAUX_D_AIDE_JURIDIQUE_DU_CENTRE_Estrie",
  "Laurentides-Lanaudière": "LISTE_DES_BUREAUX_D_AIDE_JURIDIQUE_DU_CENTRE_Laurentides_Lanaudi_re",
  "Mauricie et du Centre-du-Québec": "LISTE_DES_BUREAUX_D_AIDE_JURIDIQUE_DU_CENTRE_Mauricie_Bois_Franc",
  "Bas-Saint-Laurent Gaspésie": "LISTE_DES_BUREAUX_D_AIDE_JURIDIQUE_DU_CENTRE_Bas_Saint_Laurent_Gasp_sie",
  "Montréal Laval": "LISTE_DES_BUREAUX_D_AIDE_JURIDIQUE_DU_CENTRE_Montr_al_Laval",
  "Outaouais": "LISTE_DES_BUREAUX_D_AIDE_JURIDIQUE_DU_CENTRE_Outaouais",
  "Québec": "LISTE_DES_BUREAUX_D_AIDE_JURIDIQUE_DU_CENTRE_Qu_bec",
  "Rive-Sud": "LISTE_DES_BUREAUX_D_AIDE_JURIDIQUE_DU_CENTRE_Rive_Sud",
  "Saguenay-Lac-St-Jean": "LISTE_DES_BUREAUX_D_AIDE_JURIDIQUE_DU_CENTRE_Saguenay"
};
